// const apiUrl = "http://localhost:3001";
const apiUrl = "https://chello-api.onrender.com";
// const apiUrl = "http://192.168.1.99:3001";

export { apiUrl };
